<template>
  <StaffLayout :section="section">
    <div v-if="!hidePortalSelector">
      <PropertySelector @selected="onPropertySelected" :IsClientSelectorOnly="props.IsClientSelectorOnly"/>
    </div>

    <div class="mt-8">
      <h1 v-if="!hideHeader && property" class="py-3 text-xl border-b flex">
        <div class="flex-grow">
          <div class="font-bold">{{ section }}</div>
          <div>{{ property?.name }}</div>
        </div>
      </h1>
      <div v-if="isPropertyLoading"><Loading /></div>
      <div v-else-if="property">
        <!-- Begin Content Slot  ------------------------------------------------------------------------------------ -->
        <slot></slot>
        <!-- END Content Slot  -------------------------------------------------------------------------------------- -->
      </div>
    </div>
  </StaffLayout>
</template>

<script setup lang="ts">
import { useBldgStore } from "../store/bldgStore";
import { PortalDTO } from "../store/generatedFetchClient";
const route = useRoute();
const router = useRouter();

const bldgStore = useBldgStore();

var isPropertyLoading = computed(() => bldgStore.isLoading);
var property = computed(() => bldgStore.property);
onMounted(async () => {
  let sitecode =
    typeof route.params.sitecode === "string"
      ? (route.params.sitecode as string)
      : route.params.sitecode[0];
  console.log(`Portal Layout mounted. sitecode='${sitecode}'`);
  await bldgStore.tryGetBuildingData(sitecode);
});

let props = defineProps({
  section: {
    type: String,
    required: false,
    default: "",
  },
  darkMode: {
    type: Boolean,
    default: false,
  },
  hidePortalSelector: {
    type: Boolean,
    default: false,
  },
  hideHeader: {
    type: Boolean,
    default: false,
  },
  IsClientSelectorOnly: {
    type: Boolean,
    default: false
  }
});

let onPropertySelected = function (newProperty: PortalDTO | null) {
  if (
    newProperty &&
    newProperty.siteCode &&
    bldgStore.property &&
    newProperty?.siteCode !== bldgStore.property?.siteCode
  ) {
    console.log("Portal Layout sees property change: " + newProperty.siteCode, route);
    if (route.name) {
      router.replace({ name: route.name, params: { sitecode: newProperty.siteCode } });
    }
  }
};
</script>
